// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TypesResourceStatus = {
  Created: 'created',
  Destroyed: 'destroyed',
  PendingDestroy: 'pending-destroy',
} as const;
export type TypesResourceStatus =
  (typeof TypesResourceStatus)[keyof typeof TypesResourceStatus];

export function instanceOfTypesResourceStatus(value: any): boolean {
  for (const key in TypesResourceStatus) {
    if (Object.prototype.hasOwnProperty.call(TypesResourceStatus, key)) {
      if (
        TypesResourceStatus[key as keyof typeof TypesResourceStatus] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function TypesResourceStatusFromJSON(json: any): TypesResourceStatus {
  return TypesResourceStatusFromJSONTyped(json, false);
}

export function TypesResourceStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesResourceStatus {
  return json as TypesResourceStatus;
}

export function TypesResourceStatusToJSON(
  value?: TypesResourceStatus | null,
): any {
  return value as any;
}

export function TypesResourceStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TypesResourceStatus {
  return value as TypesResourceStatus;
}
